'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a warning containing useful information about the error that
 * caused the warning.
 * In general, it tells you what is wrong and what the correct usage
 * would look like. This is typically a text telling you that while
 * you used component "A" only component "B" or "C" are allowed.
 *
 * @private
 * @param {props} props
 *   The properties
 * @param {RectElement[]} props.not
 *   A list of components that are "not" allowed
 * @param {RectElement[]} props.only
 *   A list of "only" those components that are allowed
 * @param {Boolean} props.invalid
 *   Set this parameter if the warning is about invalid content
 * @param {Boolean} props.missing
 *   Set this parameter if the warning is about missing content
 * @param {String} props.type
 *   The type that was used and caused this warning
 */
var Warning = function Warning(props) {
  var not = props.not,
      only = props.only,
      invalid = props.invalid,
      missing = props.missing,
      type = props.type;
  // Prepare a couple of messages that might be returned

  var onlyMessage = only ? _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'strong',
      null,
      'Allowed components:'
    ),
    _react2.default.createElement(
      'ul',
      null,
      only.map(function (component, i) {
        return _react2.default.createElement(
          'li',
          { key: 'warning_item__' + i },
          component.displayName || component.name
        );
      })
    )
  ) : null;

  var notMessage = not ? _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'strong',
      null,
      'Forbidden components:'
    ),
    _react2.default.createElement(
      'ul',
      null,
      not.map(function (component, i) {
        return _react2.default.createElement(
          'li',
          { key: 'warning_item__' + i },
          component.displayName || component.name
        );
      })
    )
  ) : null;

  var message = missing ? _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'strong',
      null,
      'Error: Required slot'
    ),
    notMessage,
    onlyMessage
  ) : invalid ? _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'strong',
      null,
      'Error: Invalid component'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Tried to use ',
      type
    ),
    notMessage,
    onlyMessage
  ) : null;
  return _react2.default.createElement(
    'div',
    null,
    message
  );
};

/**
 * Allowed propTypes for `<Warning/>`
 * @private
 * @property {?ReactElement[]} not
 * @property {?ReactElement[]} only
 * @property {String} type
 * @property {?Boolean} invalid
 * @property {?Boolean} missing
 */
Warning.propTypes = {
  not: _propTypes2.default.array,
  only: _propTypes2.default.array,
  type: _propTypes2.default.string,
  invalid: _propTypes2.default.bool,
  missing: _propTypes2.default.bool
};

Warning.defaultProps = {
  not: undefined,
  only: undefined,
  type: undefined,
  invalid: undefined,
  missing: undefined
};

exports.default = Warning;
//# sourceMappingURL=warning.js.map